import { GroupDivision } from '../shared/enums/GroupDivision';
import { StatusKenoby } from '../shared/enums/StatusKenoby';
export class KenobyConsultantSearch {

    _id: string = "";
    name: string = "";
    email: string = "";
    phone: string = "";
    division: GroupDivision[] = [];
    position: string = "";
    skip: number = 0;
    totalItems: number = 0;
    limit: number = 10;
    status: StatusKenoby[] = []
    opportunity: string;
}



// WEBPACK FOOTER //
// ./src/app/models/kenobyConsultantSearch.model.ts